import { useState } from 'react';
import { Image, Modal, ModalProps } from '@tryhackme/thm-ui-components';
import { StyledButton } from '../room-banner/components/room-banner-actions/room-banner-actions.styles';
import { StyledBadgeContent, StyledBadgeTitle, StyledContent, StyledMessage } from './awards-badge-popup.styles';
import { AwardedBadgeProps } from './awards-badge-popup.types';
export const AwardsBadgePopUp = ({
  awardedBadge
}: AwardedBadgeProps, {
  ...otherModalProps
}: ModalProps) => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  return <Modal {...otherModalProps} onOpenChange={setIsPopUpOpen} open={isPopUpOpen} triggerElement={<StyledButton variant="outlined" color="secondary">
          Badge
        </StyledButton>} isSmall data-sentry-element="Modal" data-sentry-component="AwardsBadgePopUp" data-sentry-source-file="awards-badge-popup.tsx">
      <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="awards-badge-popup.tsx">
        {awardedBadge && <StyledBadgeContent>
            <Image src={`https://assets.tryhackme.com${awardedBadge.image}`} width="130" height="130" />
            <div>
              <StyledBadgeTitle>{awardedBadge.title}</StyledBadgeTitle>
              <p>{awardedBadge.description}</p>
            </div>
          </StyledBadgeContent>}
        <StyledMessage data-sentry-element="StyledMessage" data-sentry-source-file="awards-badge-popup.tsx">Complete the room to earn this badge!</StyledMessage>
      </StyledContent>
    </Modal>;
};